import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Fab, Zoom } from '@mui/material';
import { useDeviceUISettings } from 'console/shared/contexts/device-ui-settings';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
export const SaveUISettings = memo(function SaveUISettings() {
    const { onSaveDeviceUiSettings, sorting_mode, is_device_ui_settings_changed } = useDeviceUISettings();
    return (_jsx(Zoom, { in: is_device_ui_settings_changed && sorting_mode, children: _jsx(Box, { className: "iphone-safe-bottom-position", position: "fixed", right: "10px", display: "flex", flexDirection: "row-reverse", zIndex: "100", children: _jsx(Fab, { variant: "extended", color: "primary", style: {
                    bottom: isMediumUI() ? 20 : 70,
                }, onClick: onSaveDeviceUiSettings, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }) }) }));
});
